export function* downloadFile(url: string, hostElement: HTMLElement, fileName = '') {
  const a = document.createElement('a')
  a.setAttribute('href', url)
  a.setAttribute('download', fileName)
  hostElement.appendChild(a)
  a.click()
  hostElement.removeChild(a)
  yield
}
